import React, { useState, useEffect } from "react";
import { Box, Container, Pagination, Typography } from "@mui/material";
import CustomAppBar from "../../components/AppBar";
import LoaderContainer from "../../components/LoaderContainer";
import { useTranslation } from "react-i18next";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import CustomCard from "../../components/Famer/GenericCard";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../components/Alert";
import { getPickupOrders } from "../../api/biomassProcurement";

const PickupOrderList = () => {
  const [orders, setOrders] = useState([]);
  const { showAlert } = useAlert();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({
    page: 1,
    total_pages: 0,
    total_objects: 0,
  });

  useEffect(() => {
    fetchVLEsPickupOrders();
  }, []);

  const handlePageChange = () => {
    fetchVLEsPickupOrders();
  };

  const fetchVLEsPickupOrders = async () => {
    try {
      const { results, total_pages, current_page_number, total_objects } =
        await getPickupOrders();
      setOrders(results);
      setPagination({
        page: current_page_number,
        total_pages: total_pages,
        total_objects: total_objects,
      });
      setLoading(false);
    } catch (error) {
      console.error("Error fetching orders:", error);
      setLoading(false);
      showAlert("error", "Error fetching Orders");
    }
  };

  const handleDetailview = (order_id) => {
    navigate(`/pickup-order-detail/${order_id}`);
  };

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container
          maxWidth="xs"
          style={{
            height: orders.length === 0 ? "58vh" : "94vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          {orders.length !== 0 && (
            <CustomTitle>{t("Manage Inwards")}</CustomTitle>
          )}
          <div
            style={{
              overflowY: "auto",
              maxHeight: "calc(115vh - 300px)",
              textAlign: "center",
              height: "700px",
              margin: "auto",
            }}
          >
            {orders.map((order) => (
              <CustomCard
                key={order.id}
                id={order.id}
                t={t}
                data={{
                  [t("Plant Name")]: order.plant_name,
                  [t("Status")]: order.status,
                  [t("Quantity Kg")]: order.total_quantity_kg,
                  [t("Pickip Date")]: order.pickup_date,
                  [t("TransPorter Name")]: order.transporter_name,
                  [t("TransPorter Mobile")]: order.transporter_mobile,
                  [t("Transporter Vehicle Number")]:
                    order.transporter_vehicle_number,
                  [t("Transporter Driver Name")]: order.transporter_driver_name,
                  [t("Transporter Driver Number")]:
                    order.transporter_driver_mobile,
                }}
                handlePrimaryButton={() => handleDetailview(order.id)}
                disableChange="true"
                primaryLabel={t("Submit Inward")}
              />
            ))}
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {orders.length === 0 && (
              <Typography variant="subtitle1" sx={{ textAlign: "center" }}>
                {t("No orders available.")}
              </Typography>
            )}
          </div>
        </Container>
      </LoaderContainer>

      {orders.length > 0 && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            padding: "20px 0",
          }}
        >
          <Pagination
            count={pagination.total_pages}
            page={pagination.page}
            onChange={handlePageChange}
            color="primary"
            disabled={loading}
          />
        </Box>
      )}
    </>
  );
};

export default PickupOrderList;
